import React from 'react';
import cn from 'classnames';

import './index.scss';

export default function BrTextArea(props) {
  const { className, rows, defaultValue, value, ...others } = props;
  const classname = cn('br-textarea', className);
  return (
    <div className={classname} data-id="br-textarea">
      <textarea
        rows={rows || '10'}
        defaultValue={defaultValue || undefined}
        value={value || undefined}
        {...others}
      />
    </div>
  );
}
